import { FlexContainer } from '@taxdown/piccolo-web';
import styled, { css } from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';
import { pxToRem } from 'Styles/utils/utils';

export const ModalContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: ${({ theme: { colors } }) => colors.darken};
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99;
    display: flex;
    background: rgb(255, 255, 255);
    margin-top: 70px;
  }
`;

export const ModalContent = styled.div`
  width: 90%;
  height: 90%;
  display: flex;
  flex-direction: column;
  ${({ isValidationStage }) =>
    isValidationStage &&
    css`
      > iframe {
        min-height: 90%;
      }
    `}
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  > svg {
    width: 17px;
    height: 17px;
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: none;
  }
`;

export const ButtonActions = styled(FlexContainer)`
  margin-top: auto;
  > div:first-child {
    margin-right: ${pxToRem(20)};
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    flex-direction: column;
    margin: auto;
    background-color: #ffff;
    height: 25%;
    padding: 10px;
    > div:first-child {
      margin-right: 0;
      margin-bottom: ${pxToRem(20)};
    }
  }
`;
